module.exports = __webpack_public_path__ + "media/images/2-off-59e8d475412b23302edaa210048cf124.png";